// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"bbe1d8db","796":"f6788e36"}[chunkId] + ".chunk.js";
};